import { createAction } from '@reduxjs/toolkit';

const saveLuggageFormValues = createAction(
  'ui/sealink/ferryFlow/saveLuggageFormValues'
);

export { saveLuggageFormValues };
